module.exports = __webpack_public_path__ + "img/icon_tab_smart_n.4f150159.png";